import qs from 'qs';

import { api } from '@ezugi/utils';

import { API_PREFIX } from '../../../util/apiPrefix';

const VITE_API_URL = import.meta.env.VITE_API_URL ?? '';
const VITE_API_CHANGE_LANGUAGE = import.meta.env.VITE_API_CHANGE_LANGUAGE;
const URL = `${VITE_API_URL}${API_PREFIX}${VITE_API_CHANGE_LANGUAGE}`;

type ChangeLanguageResponse = {
  result: unknown;
};

type LanguageParams = {
  language: string;
  operator_id: string;
  game_id: string;
  table_id: string;
  identifier: string;
};

export const changeLanguage = async (params: LanguageParams) => {
  const response = await api.get<ChangeLanguageResponse>(`${URL}?${qs.stringify(params)}`);
  return { response, code: params.language };
};
